import {
  CLEAR_TOKEN,
  SET_TOKEN,
  SET_REFRESH_TOKEN,
} from '../actions/requestToken';
const initialState = {
  barearToken: '',
  refreshToken: '',
};

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
export default function (state = initialState, action) {
  switch (action.type) {
    case CLEAR_TOKEN:
      return initialState;
    case SET_TOKEN:
      return { ...state, barearToken: action.barearToken || '' };
    case SET_REFRESH_TOKEN:
      return { ...state, refreshToken: action.refreshToken || '' };
    default:
      return state;
  }
}
